import type { ReactNode } from "react"

import { cn } from "@/shared/utils/cn"

export interface StickyCtaProps {
  children: ReactNode
  className?: string
}

/**
 * 吸底转化栏：固定在视口底部，内部内容与 PageShell 同宽（max-w-480）居中。
 * 自带安全区 padding（pb-safe），适配刘海屏 / 全面屏底部。
 */
export function StickyCta({ children, className }: StickyCtaProps) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40">
      <div
        className={cn(
          "mx-auto max-w-[480px] border-t border-line bg-white/95 px-4 pb-safe pt-2 backdrop-blur shadow-sticky",
          className,
        )}
      >
        {children}
      </div>
    </div>
  )
}
